export type MapCoordinates = { latitude: number; longitude: number };

export type CuisineMarker = {
  key: "pizza" | "sushi" | "noodles" | "tacos" | "burgers" | "seafood" | "coffee" | "restaurant";
  glyph: string;
  label: string;
  color: string;
};

const cuisineMarkers: Array<{ pattern: RegExp; marker: CuisineMarker }> = [
  { pattern: /pizza|pizzeria/, marker: { key: "pizza", glyph: "🍕", label: "Pizza", color: "#f45a3d" } },
  { pattern: /sushi|japanese|izakaya/, marker: { key: "sushi", glyph: "🍣", label: "Sushi", color: "#ad99e6" } },
  { pattern: /noodle|ramen|pho|thai|vietnamese|chinese|korean/, marker: { key: "noodles", glyph: "🍜", label: "Noodles", color: "#f7cc51" } },
  { pattern: /taco|mexican|taqueria/, marker: { key: "tacos", glyph: "🌮", label: "Tacos", color: "#ef9a57" } },
  { pattern: /burger|hamburger|american/, marker: { key: "burgers", glyph: "🍔", label: "Burgers", color: "#d99c4b" } },
  { pattern: /seafood|fish|oyster|crab|lobster/, marker: { key: "seafood", glyph: "🐟", label: "Seafood", color: "#6ba6c9" } },
  { pattern: /coffee|cafe|café|bakery|tea/, marker: { key: "coffee", glyph: "☕", label: "Coffee", color: "#9b7653" } },
];

export function markerForCuisine(cuisine?: string | null, primaryType?: string | null): CuisineMarker {
  const source = `${cuisine || ""} ${primaryType || ""}`.toLowerCase();
  return cuisineMarkers.find(({ pattern }) => pattern.test(source))?.marker
    || { key: "restaurant", glyph: "🍴", label: "Restaurant", color: "#397a5c" };
}

export function validCoordinates(coordinates?: Partial<MapCoordinates> | null): coordinates is MapCoordinates {
  if (!coordinates) return false;
  const { latitude, longitude } = coordinates;
  return Number.isFinite(latitude) && Number.isFinite(longitude)
    && latitude! >= -90 && latitude! <= 90
    && longitude! >= -180 && longitude! <= 180;
}

export function separateOverlappingCoordinates<T extends { coordinates: MapCoordinates }>(items: T[]) {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const key = `${item.coordinates.latitude.toFixed(5)},${item.coordinates.longitude.toFixed(5)}`;
    groups.set(key, [...(groups.get(key) || []), item]);
  }

  return items.map((item) => {
    const key = `${item.coordinates.latitude.toFixed(5)},${item.coordinates.longitude.toFixed(5)}`;
    const group = groups.get(key)!;
    if (group.length === 1) return { item, coordinates: item.coordinates };
    const index = group.indexOf(item);
    const angle = (Math.PI * 2 * index) / group.length;
    const radius = 0.00018;
    return {
      item,
      coordinates: {
        latitude: item.coordinates.latitude + Math.sin(angle) * radius,
        longitude: item.coordinates.longitude + Math.cos(angle) * radius,
      },
    };
  });
}
